import { sendToConfirmRequest, getDriversRequest } from '../requests';

async function getDrivers({ commit }) {
	let drivers = await getDriversRequest();
	commit('set', (state) => { state.drivers = drivers; });
}

async function sendToConfirm(context, { orderId, driver }) {
	await sendToConfirmRequest(orderId, driver);
}

export default {
	getDrivers,
	sendToConfirm,
};
